import React, { Component } from 'react';
import { Col } from "antd";
import Center from "./Center";
import Left from "./Left";
import Right from "./Right";
import "./index.scss";


class index extends Component {
    render() {
        return (
            <div className="BI_title">
                <Col span={8}><Left data={this.props.data} /></Col>
                <Col span={8}><Center data={this.props.data} /></Col>
                <Col span={8}><Right data={this.props.data} /></Col>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/BI/home/title/index.js